import AppsTabContainer from "../containers/TabContainer/AppsTabContainer";
import ContactsTabContainer from "../containers/TabContainer/ContactsTabContainer";
import LeadsTabContainer from "../containers/TabContainer/LeadsTabContainer";
import AppsTabContentContainer from "../containers/TabContentContainer/AppsTabContentContainer";
import ContactsTabContentContainer from "../containers/TabContentContainer/ContactsTabContentContainer";
import LeadsTabContentContainer from "../containers/TabContentContainer/LeadsTabContentContainer";
import type { PageTabsConfig } from "../types/page-tabs";

export const buildTabsConfig = (): PageTabsConfig => [
    {
        id: "companies",
        title: { key: "si.advanced_search.results_section.tab.companies.text" },
        iconNameActive: "company",
        iconNameInactive: "company",
        tabComponent: LeadsTabContainer,
        panelComponent: LeadsTabContentContainer,
    },
    {
        id: "websites",
        title: { key: "si.advanced_search.results_section.tab.websites.text" },
        iconNameActive: "globe",
        iconNameInactive: "globe",
        tabComponent: LeadsTabContainer,
        panelComponent: LeadsTabContentContainer,
    },
    {
        id: "apps",
        title: { key: "si.advanced_search.results_section.tab.apps.text" },
        iconNameActive: "mobile-web",
        iconNameInactive: "mobile-web",
        tabComponent: AppsTabContainer,
        panelComponent: AppsTabContentContainer,
    },
    {
        id: "contacts",
        title: { key: "si.advanced_search.results_section.tab.contacts.text" },
        iconNameActive: "social-share",
        iconNameInactive: "social-share",
        tabComponent: ContactsTabContainer,
        panelComponent: ContactsTabContentContainer,
    },
];
